var _defs, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "91e67e3065"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91e67e3065)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 290.066406 37.5 L 84.933594 37.5 C 58.78125 37.5 37.5 58.78125 37.5 84.933594 L 37.5 290.007812 C 37.5 316.160156 58.78125 337.445312 84.933594 337.445312 L 290.007812 337.445312 C 316.160156 337.445312 337.445312 316.160156 337.445312 290.007812 L 337.445312 84.933594 C 337.5 58.78125 316.21875 37.5 290.066406 37.5 Z M 309.199219 290.066406 C 309.199219 300.652344 300.59375 309.199219 290.066406 309.199219 L 84.933594 309.199219 C 74.347656 309.199219 65.800781 300.59375 65.800781 290.066406 L 65.800781 84.933594 C 65.800781 74.347656 74.40625 65.800781 84.933594 65.800781 L 290.007812 65.800781 C 300.59375 65.800781 309.140625 74.40625 309.140625 84.933594 L 309.140625 290.066406 Z M 309.199219 290.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 105.425781 187.5 C 105.425781 232.78125 142.21875 269.574219 187.5 269.574219 C 232.78125 269.574219 269.574219 232.78125 269.574219 187.5 C 265.105469 78.652344 109.953125 78.59375 105.425781 187.5 Z M 133.726562 187.5 C 133.726562 157.839844 157.839844 133.726562 187.5 133.726562 C 217.160156 133.726562 241.273438 157.839844 241.273438 187.5 C 238.332031 258.820312 136.667969 258.820312 133.726562 187.5 Z M 133.726562 187.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 258.253906 102.59375 C 258.707031 121.273438 286.160156 121.273438 286.613281 102.59375 C 286.105469 83.914062 258.707031 83.914062 258.253906 102.59375 Z M 258.253906 102.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.87eaab5ef490bd5be3fcf02f90e3848d.svg";
export { ForwardRef as ReactComponent };